export enum UserRoleEnum {
  MASTER = 0, // Full access and controler
  USER = 1, // Cant access admin functions
  ADMIN = 2, // Dont have advanced permission (change)
}
